import Button from '@lib/Button';
import classnames from 'classnames';
import React from 'react';

import { windowScrollToTop } from '../../../../common/utils/constants';
export interface PaginationProps {
  firstPage?: number;
  currentPage: number;
  lastPage: number;
  midRadius?: number;
  endRadius?: number;
  onClick: (pageNumber: number) => void;
  className?: string;
  hideJumpToSection?: boolean;
  bgColor?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  firstPage = 1,
  currentPage = 1,
  lastPage = 1,
  midRadius = 1,
  endRadius = 1,
  onClick,
  className = '',
  // hideJumpToSection,
  bgColor,
}) => {
  lastPage = Math.max(firstPage, lastPage);
  currentPage = Math.max(currentPage, firstPage);
  currentPage = Math.min(currentPage, lastPage);

  const pages = new Set<number>();
  for (let page = firstPage; page <= Math.min(firstPage + endRadius, lastPage); page++) {
    pages.add(page);
  }
  for (
    let page = Math.max(firstPage, currentPage - midRadius);
    page <= Math.min(lastPage, currentPage + midRadius);
    page++
  ) {
    pages.add(page);
  }
  for (let page = Math.max(firstPage, lastPage - endRadius); page <= lastPage; page++) {
    pages.add(page);
  }

  const handlePageNavigation = (page) => {
    onClick(page);
    setTimeout(() => {
      windowScrollToTop(0);
    }, 0);
  };

  // const [jumpToNumber, setJumpToNumber] = useState(`${currentPage}`);

  return (
    <div
      className={`container mx-auto px-16 my-60 text-14 flex justify-center items-center space-around ${className}`}
      font-customisation="para-text"
    >
      <div className="flex flex-col md:flex-row justify-center items-center" font-customisation="para-text">
        <div className="font-medium text-theme text-opacity-50 text-14 mb-20 md:mb-0 md:mr-18">{`Page ${currentPage} of ${lastPage}`}</div>
        <div className="flex flex-no-wrap">
          <Button
            className={classnames(
              'rounded-full border-3  tracking-140 md:tracking-160 border-theme font-bold text-16 mr-10 md:mr-18 h-40 py-8 px-24 flex justify-center items-center disabled:border-disabled disabled:text-disabled disabled:cursor-not-allowed',
              {
                [bgColor + ' text-theme']: bgColor,
                'bg-white text-theme': !bgColor,
              },
            )}
            disabled={currentPage === firstPage}
            onClick={() => handlePageNavigation(Math.max(firstPage, currentPage - 1))}
            button-customisation="page-button"
          >
            PREVIOUS
          </Button>
          {Array.from(pages).map((page, index) => (
            <div key={index} className="flex justify-center items-center text-17 font-medium">
              {page !== firstPage && !pages.has(page - 1) ? <div>...</div> : null}
              <div
                className={classnames('rounded-full', {
                  'px-14 mx-0 py-4 rounded-md cursor-not-allowed text-white': page === currentPage,
                  'mx-18 cursor-pointer': page !== currentPage,
                  [bgColor + ' text-white']: bgColor && page === currentPage,
                  'border bg-theme border-theme': !bgColor && page === currentPage,
                  'ml-0': page === firstPage,
                  'mr-0': page === lastPage,
                })}
                onClick={() => {
                  page !== currentPage && handlePageNavigation(page);
                }}
              >
                {page}
              </div>
            </div>
          ))}
          <Button
            className={classnames(
              'rounded-full border-3 border-theme tracking-140 md:tracking-160 font-bold text-16 ml-18 h-40 py-8 px-24 flex justify-center items-center disabled:border-disabled disabled:text-disabled disabled:cursor-not-allowed',
              {
                [bgColor + ' text-theme']: bgColor,
                'bg-white text-theme': !bgColor,
              },
            )}
            disabled={currentPage === lastPage}
            onClick={() => handlePageNavigation(Math.min(lastPage, currentPage + 1))}
            button-customisation="page-button"
          >
            NEXT
          </Button>
        </div>
      </div>
      {/* {!hideJumpToSection && firstPage !== lastPage ? (
        <div className="absolute right-0 md:mr-30 md:flex justify-center items-center hidden">
          <div className="ml-20 mr-4">Jump to Page</div>
          <input
            type="text"
            className="border border-theme rounded-l-md h-36 w-36 text-center focus:outline-none shadow-jumpToPage"
            value={jumpToNumber}
            onChange={(e) => setJumpToNumber((e.target as HTMLInputElement).value)}
          />
          <Button
            className="bg-theme rounded-l-none text-white h-36 p-12 flex justify-center items-center border border-theme border-opacity-70"
            onClick={() => +jumpToNumber >= 1 && +jumpToNumber <= lastPage && onClick(parseInt(jumpToNumber))}
          >
            Go
          </Button>
          <div className="ml-4">of {lastPage}</div>
        </div>
      ) : null} */}
    </div>
  );
};

export default Pagination;
